import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { LoginLayout } from '@/components/modules/Layout/LoginLayout';
import { PasswordResetEditFormSkeleton } from '@/components/modules/pages/password/PasswordResetEditForm';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { loginPath } from '@/utils/router/links';
/**
 * パスワード再設定（view）
 */
export const PasswordResetEditViewSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsx(LoginLayout, Object.assign({ bottomText: _jsx(RouterLink, Object.assign({ className: 'text-current underline', to: loginPath() }, { children: "\u30ED\u30B0\u30A4\u30F3\u3078\u623B\u308B" })), className: className, title: _jsx(Skeleton, { className: 'h-[27px] w-[200px] mx-auto' }) }, { children: _jsx(PasswordResetEditFormSkeleton, { className: 'p-32' }) })));
};
